var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerify(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.87988 12.5L11.2899 14.92L16.1199 10.08",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2499 2.95C11.9399 2.36 13.0699 2.36 13.7699 2.95L15.3499 4.31C15.6499 4.57 16.2099 4.78 16.6099 4.78H18.3099C19.3699 4.78 20.2399 5.65 20.2399 6.71V8.41C20.2399 8.8 20.4499 9.37 20.7099 9.67L22.0699 11.25C22.6599 11.94 22.6599 13.07 22.0699 13.77L20.7099 15.35C20.4499 15.65 20.2399 16.21 20.2399 16.61V18.31C20.2399 19.37 19.3699 20.24 18.3099 20.24H16.6099C16.2199 20.24 15.6499 20.45 15.3499 20.71L13.7699 22.07C13.0799 22.66 11.9499 22.66 11.2499 22.07L9.66988 20.71C9.36988 20.45 8.80988 20.24 8.40988 20.24H6.67988C5.61988 20.24 4.74988 19.37 4.74988 18.31V16.6C4.74988 16.21 4.53988 15.65 4.28988 15.35L2.93988 13.76C2.35988 13.07 2.35988 11.95 2.93988 11.26L4.28988 9.67C4.53988 9.37 4.74988 8.81 4.74988 8.42V6.7C4.74988 5.64 5.61988 4.77 6.67988 4.77H8.40988C8.79988 4.77 9.36988 4.56 9.66988 4.3L11.2499 2.95Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerify);
export default __webpack_public_path__ + "static/media/verify.40c6249c53755ef35090647d33ab5997.svg";
export { ForwardRef as ReactComponent };